import { render } from "./VideoMaster.vue?vue&type=template&id=02061404&scoped=true"
import script from "./VideoMaster.vue?vue&type=script&lang=js"
export * from "./VideoMaster.vue?vue&type=script&lang=js"

import "./VideoMaster.vue?vue&type=style&index=0&id=02061404&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\Edu Katta\\Edukataa APP-Admin\\Edukatta_UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02061404"]])

export default __exports__